import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type BucketKeyComponent =
  | "SENDER_BUSINESS"
  | "RECEIVER_BUSINESS"
  | "DELIVERY_DATE"
  | "SHIP_TO_ADDRESS"
  | "DELIVERY_CHANNEL"
  | "DELIVERY_ZONE"

export interface IConsolidationRule {
  id: string;
  businessId: string;
  name: string;
  description: string | null;
  bucketKeyComponents: BucketKeyComponent[];
  maxOrdersPerBucket: number;
  maxDnPerRun: number;
  sameDayOnly: boolean;
  matchAddressStrict: boolean;
  autoRunEnabled: boolean;
  isActive: boolean;
  priority: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ICreateConsolidationRuleInput {
  name: string;
  description?: string | null;
  bucketKeyComponents: BucketKeyComponent[];
  maxOrdersPerBucket?: number;
  maxDnPerRun?: number;
  sameDayOnly?: boolean;
  matchAddressStrict?: boolean;
  autoRunEnabled?: boolean;
  isActive?: boolean;
  priority?: number;
}

export const list = async (data?: {
  filter?: { isActive?: boolean | null };
  offset?: { limit: number; skip: number };
}) =>
  httpRequest.post("/ord/consolidation-rule/list", (data ?? {}) as never) as Promise<{
    rows: IConsolidationRule[];
    count: number;
  }>;

export const create = async (input: ICreateConsolidationRuleInput) =>
  httpRequest.post("/ord/consolidation-rule", input as never) as Promise<IConsolidationRule>;

export const update = async (id: string, patch: Partial<ICreateConsolidationRuleInput>) =>
  httpRequest.put(`/ord/consolidation-rule/${id}`, patch as never) as Promise<IConsolidationRule>;

export const remove = async (id: string) =>
  httpRequest.del(`/ord/consolidation-rule/${id}`);
